import { useCallback } from "react";
import type { FlashCardUI } from "../models/FlashcardUI";

type FlashcardSessionActions = {
  updateCard: (id: number, updater: (card: FlashCardUI) => FlashCardUI) => void;
};

export const useFlashcardActions = (
  updateCard: FlashcardSessionActions["updateCard"],
) => {
  const toggleBookmark = useCallback(
    (id: number) => {
      updateCard(id, (card) => ({
        ...card,
        isBookmarkSelected: !card.isBookmarkSelected,
      }));
    },
    [updateCard],
  );

  const toggleExpand = useCallback(
    (id: number) => {
      updateCard(id, (card) => ({
        ...card,
        isExpanded: !card.isExpanded,
      }));
    },
    [updateCard],
  );

  const onLike = useCallback(
    (id: number) => {
      updateCard(id, (card) => ({
        ...card,
        isLiked: card.isLiked ? false : true,
        isDisLiked: false,
        likedCount: card.isLiked
          ? Math.max(0, card.likedCount - 1)
          : card.likedCount + 1,
      }));
    },
    [updateCard],
  );

  const onDislike = useCallback(
    (id: number) => {
      updateCard(id, (card) => ({
        ...card,
        isLiked: false,
        isDisLiked: card.isDisLiked ? false : true,
        likedCount: card.isLiked
          ? Math.max(0, card.likedCount - 1)
          : card.likedCount,
      }));
    },
    [updateCard],
  );

  const markCompleted = useCallback(
    (id: number) => {
      updateCard(id, (card) => ({ ...card, isCompleted: true }));
    },
    [updateCard],
  );

  return {
    toggleBookmark,
    toggleExpand,
    onLike,
    onDislike,
    markCompleted,
  };
};
